import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { ShoppingCart } from 'lucide-react'

interface AddProductsAlertModalProps {
  isOpen: boolean
  onClose: () => void
}

const AddProductsAlertModal: React.FC<AddProductsAlertModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation()
  const isRTL = useSelector((state: RootState) => state.settings.settings.language === 'ar')

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/20 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className={`relative w-full max-w-md rounded-3xl bg-white shadow-[0px_24px_48px_rgba(18,18,23,0.08)] p-8 space-y-6 ${isRTL ? 'text-right' : 'text-left'}`}>
        <div className="flex flex-col items-center gap-2">
          <h3 className="text-2xl font-medium text-neutral-900 text-center font-['IBM Plex Sans Arabic']">
            {t('table.alert')}
          </h3>
          <p className="text-base text-black text-center leading-6 font-['IBM Plex Sans Arabic']">
            {t('table.must_add_products_first')}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <button
            onClick={onClose}
            className="w-full h-12 rounded-xl bg-flutter-button text-white font-semibold flex items-center justify-center gap-2 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.15)]"
          >
            <ShoppingCart className="h-4 w-4" />
            <span className="font-['IBM Plex Sans Arabic']">
              {t('common.ok')}
            </span>
          </button>
          <button
            onClick={onClose}
            className="h-12 rounded-xl border border-black bg-white text-black font-semibold flex items-center justify-center font-['IBM Plex Sans Arabic']"
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddProductsAlertModal

